import { render, staticRenderFns } from "./ConfigCadastrosRestritos.vue?vue&type=template&id=950fc882&scoped=true&lang=pug&"
import script from "./ConfigCadastrosRestritos.vue?vue&type=script&lang=js&"
export * from "./ConfigCadastrosRestritos.vue?vue&type=script&lang=js&"
import style0 from "./ConfigCadastrosRestritos.vue?vue&type=style&index=0&id=950fc882&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950fc882",
  null
  
)

export default component.exports